export enum URLS {
  ACCOUNT = '/overview/account/:tab',
  ORDERS = '/overview/orders/',
  PRODUCTS = '/overview/services-calendar/',
  INTEGRATION = '/overview/partners/:company/',
  VENDORS = '/vendors/',
  OWNER_MANAGE_ORDER = '/owner/:ownerOrderUuid/?showPrices=True', // The owner always sees the prices
  CHECKOUT_DETAILS = '/store/:storeId/:orderId/checkout-details/',
  CHECKOUT = '/store/:storeId/checkout/:orderId/:customerId/',
  CART_DETAILS = '/store/:storeId/cart/',
  ONBOARDING_VIDEO = '/onboarding-video/',
}
